/* eslint-disable no-unused-vars */
import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Container,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Card,
  Row,
} from "reactstrap";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import ApiContext from "services/ApiContext";

function ResetPassword() {
  const Axios = useContext(ApiContext);
  const resetToken = new URLSearchParams(window.location.search).get("token");
  const [message, setMessage] = useState();
  const [visible, setVisible] = useState();
  const history = useHistory();
  const validationSchema = Yup.object().shape({
    ResetToken: Yup.string(),
    NewPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .max(40, "Password must not exceed 40 characters"),
    MatchPassword: Yup.string().oneOf(
      [Yup.ref("NewPassword"), null],
      "Confirm Password does not match"
    ),
  });

  const onShowAlert = () => {
    setVisible(true);
    window.setTimeout(() => {
      setVisible(false);
      // navigate("/");
    }, 3000);
  };

  const { mutate, isLoading } = useMutation(
    (data) =>
      Axios.put("/public/Account/PasswordReset", {
        ResetToken: resetToken,
        NewPassword: data.NewPassword,
      }),
    {
      onError: async (err) => {
        setMessage({
          data: `${err.response.data.MESSAGE}`,
          type: "alert-danger",
        });
        onShowAlert();
      },

      onSuccess: async (res) => {
        setMessage({
          data: `${res.data.MESSAGE}`,
          type: "alert-success",
        });
        onShowAlert();
        setTimeout(() => {
          history.push("/auth/Login");
        }, 3000);
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      NewPassword: "",
      MatchPassword: "",
    },
    validationSchema,

    onSubmit: (data) => {
      mutate(data);
    },
  });

  return (
    <div className="mx-auto d-block">
      <Container>
        {message !== undefined && message && (
          <Modal isOpen={visible} toggle={() => setVisible(false)}>
            <ModalBody className={`text-center text-white ${message.type}`}>
              {message.data}
            </ModalBody>
            <ModalFooter>
              <Button
                color="link"
                type="button"
                onClick={() => setVisible(false)}
              >
                Okay
              </Button>
            </ModalFooter>
          </Modal>
        )}
        <Card>
          <Row>
            <Col md="6">
              <img
                className="w-100 h-100 img mb-5"
                src={require("assets/img/Page/ForgotPassword/resetpassword.png")}
                alt="emptyCart"
              />
            </Col>
            <Col md="6">
              <h2 className="text-center p-3 font-weight-bold">
                Reset Your Password
              </h2>
              <p className="text-center p-3">Enter your new password.</p>
              <div className="text-center p-3">
                <Form onSubmit={formik.handleSubmit}>
                  <div className="text-left pt-2 font-weight-bold">
                    <Label htmlFor="NewPassword"> NEW PASSWORD </Label>
                    <Input
                      className={
                        formik.errors.NewPassword ? "is-invalid" : "is-valid"
                      }
                      name="NewPassword"
                      type="password"
                      onChange={formik.handleChange}
                      value={formik.values.NewPassword}
                    />
                    <div className="text-danger">
                      {formik.errors.NewPassword
                        ? formik.errors.NewPassword
                        : null}
                    </div>
                  </div>
                  <div className="text-left pt-2 font-weight-bold">
                    <Label htmlFor="MatchPassword">CONFIRM PASSWORD</Label>
                    <Input
                      className={
                        formik.errors.MatchPassword ? "is-invalid" : "is-valid"
                      }
                      name="MatchPassword"
                      type="password"
                      onChange={formik.handleChange}
                      value={formik.values.MatchPassword}
                    />
                    <div className="text-danger">
                      {formik.errors.MatchPassword
                        ? formik.errors.MatchPassword
                        : null}
                    </div>
                  </div>
                  <Button
                    color="success"
                    className="text-center w-100 mt-4 p-2 button-white-template"
                  >
                    {isLoading ? "Loading..." : "Reset Password"}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Card>
      </Container>
      <div
        className="full-page-background"
        style={{
          background: `url(${require("assets/img/bg/download.jpg")})`,
        }}
      />
    </div>
  );
}

export default ResetPassword;
